export default __webpack_public_path__ + "static/media/Ring.c73f0134.png";